// import node module libraries
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Image, Container, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import MDI icons
import Icon from '@mdi/react';
import { mdiFacebook, mdiTwitter, mdiInstagram } from '@mdi/js';

// import media files
import FooterLogo from 'assets/images/brand/logo/logo.svg';
import AppStore from 'assets/images/svg/appstore.svg';
import PlayStore from 'assets/images/svg/playstore.svg';

const FooterHaeppyappWithLinks = () => {
	const { t } = useTranslation(); // useTranslation-Hook

	return (
		<Fragment>
			<footer className="pt-lg-10 pt-5 footer bg-white">
				<Container>
					<Row>
						<Col lg={4} md={6} sm={12}>
							{/* about company  */}
							<div className="mb-4">
								<Image src={FooterLogo} width={250} alt="haeppy.app Logo" className="logo" />
								<div className="mt-4">
									<p>
										{t('With haeppy.app, you can automate your multi-channel processes as an e-commerce retailer. Interfaces to the most popular retailer portals allow you to automate returns, invoice uploads, and much more, saving you money.')}
									</p>
								</div>
							</div>
						</Col>
						<Col lg={{ span: 2, offset: 1 }} md={3} sm={6}>
							<div className="mb-4">
								{/* list */}
								<h3 className="fw-bold mb-3">{t('Company')}</h3>
								<ListGroup
									as="ul"
									bsPrefix="list-unstyled"
									className="nav nav-footer flex-column nav-x-0"
								>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/pages/compare-plan" className="nav-link">
											{t('Prices & Plans')}
										</Link>
									</ListGroup.Item>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/about/imprint" className="nav-link">
											{t('Imprint')}
										</Link>
									</ListGroup.Item>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/about/privacy" className="nav-link">
											{t('Privacy')}
										</Link>
									</ListGroup.Item>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/about/terms-and-conditions" className="nav-link">
											{t('Terms and Conditions')}
										</Link>
									</ListGroup.Item>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/pages/contact" className="nav-link">
											{t('Contact us')}
										</Link>
									</ListGroup.Item>
								</ListGroup>
							</div>
						</Col>
						<Col lg={2} md={3} sm={6}>
							<div className="mb-4">
								{/* list  */}
								<h3 className="fw-bold mb-3">{t('Support')}</h3>
								<ListGroup
									as="ul"
									bsPrefix="list-unstyled"
									className="nav nav-footer flex-column nav-x-0"
								>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/help-center" className="nav-link">
											{t('Help Center')}
										</Link>
									</ListGroup.Item>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/help-center/faq" className="nav-link">
											{t('FAQs')}
										</Link>
									</ListGroup.Item>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/help-center/guide" className="nav-link">
											{t('Guides & Resources')}
										</Link>
									</ListGroup.Item>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/help-center/support" className="nav-link">
											{t('Service Ticket')}
										</Link>
									</ListGroup.Item>
									<ListGroup.Item as="li" bsPrefix=" ">
										<Link to="/marketing/help-center/statuspage" className="nav-link">
											{t('Monitoring / Status')}
										</Link>
									</ListGroup.Item>
								</ListGroup>
							</div>
						</Col>
						<Col lg={3} md={12} sm={12}>
							{/* contact info */}
							<div className="mb-4">
								<h3 className="fw-bold mb-3">{t('Contact')}</h3>
								<p className="mb-1">
									<Link to="#">hallo@die-webarchitekten.de</Link>
								</p>
							</div>
						</Col>
					</Row>
					<Row className="align-items-center g-0 border-top py-2 mt-6">
						{/* Desc  */}
						<Col lg={4} md={5} sm={12}>
							<span>haeppy.app :)</span>
						</Col>
						{/*  Links  */}
						<Col
							lg={8}
							md={7}
							sm={12}
							className="d-md-flex justify-content-end"
						>
							<nav className="nav nav-footer">
								<Link className="nav-link ps-0" to="/marketing/about/imprint">
									{t('Imprint')}
								</Link>
								<Link className="nav-link px-2 px-md-3" to="/marketing/about/privacy">
									{t('Privacy')}
								</Link>
								<Link className="nav-link" to="/marketing/about/terms-and-conditions">
									{t('Terms and Conditions')}
								</Link>
							</nav>
						</Col>
					</Row>
				</Container>
			</footer>
		</Fragment>
	);
};

export default FooterHaeppyappWithLinks;
